module.exports = __webpack_public_path__ + "img/019.5d3c8f77.png";